<template>
  <div class="position-relative">
    <!-- トグルボタン（右端に固定） -->
    <button
      class="btn btn-aside-toggle shadow-none position-absolute top-2 end-0 mt-6"
      :style="{ zIndex: 10000, ...toggleButtonStyle }"
      @click="toggleSidenav"
      @mouseenter="isHovered = true"
      @mouseleave="isHovered = false"
    >
      <i
        :class="[
          'fas',
          isHovered
            ? this.$store.state.isSidenavOpen
              ? 'fa-chevron-left'
              : 'fa-chevron-right'
            : 'fa-bars',
          'fa-2x',
        ]"
      ></i>
    </button>

    <!-- スマホ 左メニューの閉じるボタン -->
    <button
      v-show="isSidenavOpen"
      class="btn btn-aside-close-sp shadow-none position-absolute end-0 mt-6"
      :style="{ zIndex: 10000 }"
      @click="toggleSidenav"
    >
      <i class="fas fa-times-circle fa-2x"></i>
    </button>

    <!-- sidenav -->
    <aside
      v-show="isSidenavOpen"
      id="sidenav-main"
      :class="[
        'mt-6 pt-4 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl',
        this.$store.state.isMobileOpen ? 'bg-white shadow-lg px-2' : 'ps-3',
      ]"
    >
      <div
        v-if="chatbots.length < 50"
        class="d-flex align-items-center w-100 mt-5 mb-2 gap-2"
      >
        <!-- 50個未満なら通常の新規作成ボタン -->
        <soft-button
          class="w-90"
          variant="gradient"
          :color="isDeleteMode ? 'danger' : 'warning'"
          :disabled="isDeleteMode && selectedBots.length === 0"
          @click.prevent="
            isDeleteMode ? deleteSelectedBots() : $emit('bot-init')
          "
        >
          <template v-if="isDeleteMode">
            <i class="fas fa-trash-alt me-1"></i>
            チャットを一括削除
          </template>

          <template v-else>
            <i class="fas fa-plus me-1"></i>
            チャットを新規作成
          </template>
        </soft-button>
        <!-- 削除 / キャンセル -->
        <soft-button
          v-if="chatbots.length >= 1"
          class="btn-icon-only"
          variant="gradient"
          color="secondary"
          @click="toggleDeleteMode"
        >
          <i
            :class="['fas', isDeleteMode ? 'fa-times-circle' : 'fa-trash-alt']"
          ></i>
        </soft-button>
      </div>

      <!-- 50個以上なら無効化されたボタン -->
      <div
        v-if="chatbots.length >= 50"
        class="d-flex align-items-center w-100 mt-5 mb-2 gap-2"
      >
        <soft-button
          class="w-90"
          variant="gradient"
          :color="isDeleteMode ? 'danger' : 'secondary'"
          :disabled="selectedBots.length === 0"
          @click.prevent="isDeleteMode ? deleteSelectedBots() : ''"
        >
          <template v-if="isDeleteMode">
            <i class="fas fa-trash-alt me-1"></i>
            チャットを一括削除
          </template>

          <template v-else>
            <i class="fas fa-ban me-1"></i>
            チャットルームが<br />上限の50個に達しました。
          </template>
        </soft-button>
        <soft-button
          v-if="chatbots.length >= 1"
          class="btn-icon-only"
          variant="gradient"
          color="secondary"
          @click="toggleDeleteMode"
        >
          <i
            :class="['fas', isDeleteMode ? 'fa-times-circle' : 'fa-trash-alt']"
          ></i>
        </soft-button>
      </div>

      <sidenav-list
        :card-bg="customClass"
        :chatbots="chatbots"
        :isDeleteMode="isDeleteMode"
        :selectedBots="selectedBots"
        @bot-toggle="toggleBotSelection"
        @bot-selected="handleBotSelected"
        @bot-deleted="$emit('bot-deleted', $event)"
      />
    </aside>
  </div>
</template>

<script>
import SidenavList from './SidenavList.vue'
import SoftButton from '@/components/SoftButton.vue'
import { mapState } from 'vuex'

export default {
  name: 'SidenavIndex',
  components: {
    SoftButton,
    SidenavList,
  },
  props: {
    customClass: {
      type: String,
      default: '',
    },
    chatbots: {
      type: Array,
      required: false,
      default: () => [],
    },
    isDeleteMode: Boolean,
  },
  data() {
    return {
      isHovered: false,
      selectedBots: [],
    }
  },
  computed: {
    ...mapState(['isSidenavOpen']),
    toggleButtonStyle() {
      return {
        marginRight: this.$store.state.isSidenavOpen ? '0px' : '190px',
        paddingRight: this.$store.state.isSidenavOpen ? '0px' : '1.5rem',
        transition: 'right 1.0s ease',
      }
    },
  },
  methods: {
    toggleSidenav() {
      // Vuexに状態を反映
      this.$store.commit('setSidenavState', !this.$store.state.isSidenavOpen)
    },
    handleBotSelected(event) {
      this.$emit('bot-selected', event)
      // スマホか判定（必要なら）
      if (this.$store.state.isMobileOpen) {
        this.toggleSidenav()
      }
    },
    toggleDeleteMode() {
      this.$emit('handle-delete-mode', !this.isDeleteMode)
      this.selectedBots = []
    },
    toggleBotSelection(botId) {
      if (this.selectedBots.includes(botId)) {
        this.selectedBots = this.selectedBots.filter((id) => id !== botId)
      } else {
        this.selectedBots.push(botId)
      }
    },
    deleteSelectedBots() {
      this.$emit('bot-deleted', this.selectedBots)
    },
  },
}
</script>
